import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UploadTestCenterUsersService } from "../../shared/services/upload-test-center-users/upload-test-center-users.service";
import { first } from "rxjs/operators";
import { AlertService } from 'src/app/shared';

@Component({
  selector: "app-upload-test-center-user",
  templateUrl: "./upload-test-center-user.component.html",
  styleUrls: ["./upload-test-center-user.component.scss"]
})
export class UploadTestCenterUserComponent implements OnInit {
  fileType: any =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataAvailable = false;
  dataCount: any;
  uploadType: any = "import";
  error: any;
  errorMessage = null;
  successMessage = null;
  uploadtestcenterdata: any;
  sender = "upload-test-center-users";
  errorOnly = false;
  errorCount = 0;
  showAll = true;

  constructor(
    private router: Router,
    private alertService: AlertService,
    private uploaltestcenterusersservice: UploadTestCenterUsersService
  ) {}

  ngOnInit() {}

  ondocImport(e) {
    this.uploadtestcenterdata = e;
    if (this.uploadtestcenterdata.status == "error"){
      this.error = this.uploadtestcenterdata.error;
      return;
    }

    this.errorCount = 0

    for (var i=0; i<this.uploadtestcenterdata.length; i++){
      if (this.uploadtestcenterdata[i].errors.length >0){
        this.errorCount += 1;
        
      }
    }

    if (this.errorCount >0){
      this.alertService.err (this.sender, "Found " + this.errorCount + " errors");
    }


   // console.log(" this.uploadtestcenterdata", this.uploadtestcenterdata);
  }

  ondocError(e) {
    this.error = e;
  }

  onConfirm() {
    this.uploaltestcenterusersservice
      .saveUploadedTestCenterUsers(this.uploadtestcenterdata)
      .pipe(first())
      .subscribe(res => {
        this.router.navigate(["manager/upload-test-center-user-list"]);
      });
  }
}
